<template>
  <div>
    <app-header></app-header>
    <div class="app-main">
      <app-silder></app-silder>
      <div class="app-main-inner">
        <div class="comingSoon-box">
          <h1>{{ $t("lang.homePage1") }}</h1>
          <div class="comingSoon-info" v-if="comingSoon===null">{{ $t("lang.homePage2") }}</div>
          <div class="comingSoon-info" v-else>
            <span class="padding-left-0" v-if="comingSoon.courseType!==null">
              <i v-if="comingSoon.courseType===0">{{ $t("lang.homePage3") }}</i>
              <i v-if="comingSoon.courseType===1">{{ $t("lang.homePage4") }}</i>
              <i v-if="comingSoon.courseType===2">{{ $t("lang.homePage5") }}</i>
              <i v-if="comingSoon.courseType===3">{{ $t("lang.homePage34") }}</i>
            </span>
            <span v-if="comingSoon.courseName || comingSoon.lessonName">{{comingSoon.courseName}} {{comingSoon.lessonName}}</span>
            <template v-if="comingSoon.stuSimpInfo">
              <!-- <a v-for="item in comingSoon.stuSimpInfo" :key="item.id" >
                <span v-if="item.childEnName">{{item.childEnName}}</span>
              </a> -->
              <!-- <span v-if="comingSoon.stuSimpInfo[0].childEnName">{{comingSoon.stuSimpInfo[0].childEnName}}</span> -->
              <span v-if="comingSoon.stuSimpInfo[0].childEnName">{{language === 'cn' ? comingSoon.stuSimpInfo[0].childCnName : comingSoon.stuSimpInfo[0].childEnName }}</span>
            </template>
            <span class="border-none" v-if="timeZone">{{$utils.formatLocalTimeYYYYMMDDHHmmss(comingSoon.localStartTime,timeZone)}}</span>
            <a v-if="comingSoon.roomUrl" v-bind:href="comingSoon.roomUrl" target="_blank" rel="noopener" class="enter-btn">{{ $t("lang.homePage8") }}</a>
          </div>
        </div>
        <div class="ScheduledCount-box">
          <el-table
              :data="ScheduledCount"
              style="width: 100%"
              border>
              <el-table-column :label="$t('lang.homePage6')" align="center" >
                <template slot-scope="scope">
                  <div>{{scope.row.bookingNum}}</div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('lang.homePage7')" align="center">
                <template slot-scope="scope">
                  <div>{{scope.row.bookedNum}}</div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('lang.homePage35')" align="center">
                <template slot-scope="scope">
                  <div>{{scope.row.teamNum}}</div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('lang.homePage4')" align="center">
                <template slot-scope="scope">
                  <div>{{scope.row.openClassNum}}</div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('lang.homePage34')" align="center">
                <template slot-scope="scope">
                  <div>{{scope.row.auditionClassNum}}</div>
                </template>
              </el-table-column>
          </el-table>
        </div>
        <div class="syllabus-box">
          <div class="syllabus-box-top">
            <h1>{{$t('lang.homePage9')}}</h1>
            <span><i class="class-bgc-open"></i>{{$t('lang.homePage4')}}</span>
            <span><i class="class-bgc-private"></i>{{$t('lang.homePage3')}}</span>
            <span><i class="class-bgc-1Vn"></i>{{$t('lang.homePage5')}}</span>
            <span><i class="class-bgc-auditions"></i>{{$t('lang.homePage34')}}</span>
            <router-link to="/booking" tag="a" class="syllabus-btn fr">{{$t('lang.userPage92')}}</router-link>
          </div>
          <div class="syllabus-box-inner" :class="[scrollFlag ? 'scroll' : 'normal']">
            <div class="table-tip" v-if="!isDemofade">
              <i></i>
              <div v-if="tableTip.localtime || tableTip.date" class="table-tip-info">
                <h1 v-if="tableTip.localtime">{{$t('lang.homePage10')}}</h1>
                <span v-if="tableTip.localtime">{{$t('lang.homePage11')}}: <b>{{tableTip.localtime}}</b></span>
                <span v-if="tableTip.beijingtime">{{$t('lang.homePage12')}}: <b>{{tableTip.beijingtime}}</b></span>
                <h1 v-if="tableTip.date">{{$t('lang.homePage13')}}</h1>
                <span v-if="tableTip.displayName">{{$t('lang.homePage14')}}: <b>{{tableTip.displayName}}</b></span>
                <span v-if="tableTip.age">{{$t('lang.homePage15')}}: <b>{{tableTip.age}}</b></span>
                <span v-if="tableTip.level">{{$t('lang.homePage16')}}: <b>{{tableTip.level}}</b></span>
                <span v-if="tableTip.lesson">{{$t('lang.homePage17')}}: <b>{{tableTip.lesson}}</b></span>
                <span v-if="tableTip.date">{{$t('lang.homePage18')}}: <b>{{tableTip.date}} {{tableTip.time}}</b></span>
              </div>
              <div v-else class="table-tip-info">
                <h1>{{$t('lang.homePage19')}}</h1>
              </div>
            </div>
            <div class="table-syllabus" v-if="!isDemofade">
                <el-table
                  :data="tableData"
                  :highlight-current-row="false"
                  border
                  style="width: 100%"
                  tooltip-effect="dark"
                  v-if="this.timeZone">
                  <el-table-column
                    label="" width="110" align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.hot0" class="hot"><i></i> {{scope.row.text}}</div>
                      <div v-else-if="scope.row.night0" class="night">{{scope.row.text}}</div>
                      <div v-else>{{scope.row.text}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('lang.homePage20')"
                    :render-header="renderHeader"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="hot" v-if="scope.row.hot1"></div>
                      <div class="gray" v-if="scope.row.expired1"></div>
                      <div v-else class="timeZomePopover" v-on:mouseenter="tableTipIn(`${scope.row.localDay1} ${scope.row.localTime1}`,`${scope.row.BeijingDay1} ${scope.row.BeijingTime1}`)" v-on:mouseleave="tableTipOut">
                      </div>
                      <div class="temp" v-if="scope.row.selectedTemp1 && !scope.row.selected1"> 
                        <el-checkbox v-model="scope.row.selectedTemp1" @change="cancelTime(scope.row.selectedTempId1)">{{scope.row.selectedTempText1}}</el-checkbox>
                      </div>
                      <div class="selected" v-if="scope.row.selected1"> 
                        <div v-if="scope.row.expired1" class="passed-selected">{{$t('lang.homePage27')}}</div>
                        <div v-else class="p-r">
                          <div class="selected-layer"></div>
                          <el-checkbox v-model="scope.row.selected1">{{scope.row.selectedText1}}</el-checkbox>
                        </div>
                      </div>
                      <div class="booked" v-if="scope.row.booked1">
                        <div v-if="scope.row.booked1.lessonStatus===2" class="lessonStatus lessonStatus-2">
                          <span v-if="scope.row.booked1.displayName">{{$t('lang.homePage28')}}-{{scope.row.booked1.displayName}}</span>
                          <span v-else>{{$t('lang.homePage28')}}</span>
                        </div>
                        <div v-else-if="scope.row.booked1.lessonStatus===3" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage29')}}
                        </div>
                        <div v-else-if="scope.row.booked1.lessonStatus===4" class="lessonStatus lessonStatus-4">
                          {{$t('lang.homePage30')}}
                        </div>
                        <div v-else-if="scope.row.booked1.lessonStatus===5" class="lessonStatus lessonStatus-5">
                          {{$t('lang.homePage31')}}
                        </div>
                        <div v-else-if="scope.row.booked1.lessonStatus===6" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage32')}}
                        </div>
                        <div v-else class="courseType" :class="`courseType-${scope.row.booked1.courseType}`" v-on:mouseenter="tableTipIn(null, null, scope.row.booked1.displayName, scope.row.booked1.age, scope.row.booked1.level, scope.row.booked1.lesson, scope.row.booked1.date, scope.row.booked1.time)" v-on:mouseleave="tableTipOut">
                          <span v-if="scope.row.booked1.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked1.displayName}}</span>
                          <span v-else>{{$t('lang.homePage13')}}</span>
                          <router-link v-if="scope.row.booked1.roomId" :to="{path:'/classroom/lessonInfo',query:{lessonId:scope.row.booked1.id,title:scope.row.booked1.lesson,roomId:scope.row.booked1.roomId,lessonModel:scope.row.booked1.lessonModel,documentId:scope.row.booked1.documentId}}" class="prepare" tag="div">{{$t('lang.homePage33')}}</router-link>
                          <div v-else class="no-prepare">
                            <i v-if="scope.row.booked1.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked1.displayName}}</i>  
                            <i v-else>{{$t('lang.homePage13')}}</i>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('lang.homePage21')"
                    :render-header="renderHeader"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="hot" v-if="scope.row.hot2"></div>
                      <div class="gray" v-if="scope.row.expired2"></div>
                      <div v-else class="timeZomePopover" v-on:mouseenter="tableTipIn(`${scope.row.localDay2} ${scope.row.localTime2}`,`${scope.row.BeijingDay2} ${scope.row.BeijingTime2}`)" v-on:mouseleave="tableTipOut">
                      </div>
                      <div class="temp" v-if="scope.row.selectedTemp2 && !scope.row.selected2"> 
                        <el-checkbox v-model="scope.row.selectedTemp2" @change="cancelTime(scope.row.selectedTempId2)">{{scope.row.selectedTempText2}}</el-checkbox>
                      </div>
                      <div class="selected" v-if="scope.row.selected2"> 
                        <div v-if="scope.row.expired2" class="passed-selected">{{$t('lang.homePage27')}}</div>
                        <div v-else class="p-r">
                          <div class="selected-layer"></div>
                          <el-checkbox v-model="scope.row.selected2">{{scope.row.selectedText2}}</el-checkbox>
                        </div>
                      </div>
                      <div class="booked" v-if="scope.row.booked2">
                        <div v-if="scope.row.booked2.lessonStatus===2" class="lessonStatus lessonStatus-2">
                          <span v-if="scope.row.booked2.displayName">{{$t('lang.homePage28')}}-{{scope.row.booked2.displayName}}</span>
                          <span v-else>{{$t('lang.homePage28')}}</span>
                        </div>
                        <div v-else-if="scope.row.booked2.lessonStatus===3" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage29')}}
                        </div>
                        <div v-else-if="scope.row.booked2.lessonStatus===4" class="lessonStatus lessonStatus-4">
                          {{$t('lang.homePage30')}}
                        </div>
                        <div v-else-if="scope.row.booked2.lessonStatus===5" class="lessonStatus lessonStatus-5">
                          {{$t('lang.homePage31')}}
                        </div>
                        <div v-else-if="scope.row.booked2.lessonStatus===6" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage32')}}
                        </div>
                        <div v-else class="courseType" :class="`courseType-${scope.row.booked2.courseType}`" v-on:mouseenter="tableTipIn(null, null, scope.row.booked2.displayName, scope.row.booked2.age, scope.row.booked2.level, scope.row.booked2.lesson, scope.row.booked2.date, scope.row.booked2.time)" v-on:mouseleave="tableTipOut">
                          <span v-if="scope.row.booked2.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked2.displayName}}</span>
                          <span v-else>{{$t('lang.homePage13')}}</span>
                          <router-link v-if="scope.row.booked2.roomId" :to="{path:'/classroom/lessonInfo',query:{lessonId:scope.row.booked2.id,title:scope.row.booked2.lesson,roomId:scope.row.booked2.roomId,lessonModel:scope.row.booked2.lessonModel,documentId:scope.row.booked2.documentId}}" class="prepare" tag="div">{{$t('lang.homePage33')}}</router-link>
                          <div v-else class="no-prepare">
                            <i v-if="scope.row.booked2.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked2.displayName}}</i>  
                            <i v-else>{{$t('lang.homePage13')}}</i>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('lang.homePage22')"
                    :render-header="renderHeader"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="hot" v-if="scope.row.hot3"></div>
                      <div class="gray" v-if="scope.row.expired3"></div>
                      <div v-else class="timeZomePopover" v-on:mouseenter="tableTipIn(`${scope.row.localDay3} ${scope.row.localTime3}`,`${scope.row.BeijingDay3} ${scope.row.BeijingTime3}`)" v-on:mouseleave="tableTipOut">
                      </div>
                      <div class="temp" v-if="scope.row.selectedTemp3 && !scope.row.selected3"> 
                        <el-checkbox v-model="scope.row.selectedTemp3" @change="cancelTime(scope.row.selectedTempId3)">{{scope.row.selectedTempText3}}</el-checkbox>
                      </div>
                      <div class="selected" v-if="scope.row.selected3"> 
                        <div v-if="scope.row.expired3" class="passed-selected">{{$t('lang.homePage27')}}</div>
                        <div v-else class="p-r">
                          <div class="selected-layer"></div>
                          <el-checkbox v-model="scope.row.selected3">{{scope.row.selectedText3}}</el-checkbox>
                        </div>
                      </div>
                      <div class="booked" v-if="scope.row.booked3">
                        <div v-if="scope.row.booked3.lessonStatus===2" class="lessonStatus lessonStatus-2">
                          <span v-if="scope.row.booked3.displayName">{{$t('lang.homePage28')}}-{{scope.row.booked3.displayName}}</span>
                          <span v-else>{{$t('lang.homePage28')}}</span>
                        </div>
                        <div v-else-if="scope.row.booked3.lessonStatus===3" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage29')}}
                        </div>
                        <div v-else-if="scope.row.booked3.lessonStatus===4" class="lessonStatus lessonStatus-4">
                          {{$t('lang.homePage30')}}
                        </div>
                        <div v-else-if="scope.row.booked3.lessonStatus===5" class="lessonStatus lessonStatus-5">
                          {{$t('lang.homePage31')}}
                        </div>
                        <div v-else-if="scope.row.booked3.lessonStatus===6" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage32')}}
                        </div>
                        <div v-else class="courseType" :class="`courseType-${scope.row.booked3.courseType}`" v-on:mouseenter="tableTipIn(null, null, scope.row.booked3.displayName, scope.row.booked3.age, scope.row.booked3.level, scope.row.booked3.lesson, scope.row.booked3.date, scope.row.booked3.time)" v-on:mouseleave="tableTipOut">
                          <span v-if="scope.row.booked3.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked3.displayName}}</span>
                          <span v-else>{{$t('lang.homePage13')}}</span>
                          <router-link v-if="scope.row.booked3.roomId" :to="{path:'/classroom/lessonInfo',query:{lessonId:scope.row.booked3.id,title:scope.row.booked3.lesson,roomId:scope.row.booked3.roomId,lessonModel:scope.row.booked3.lessonModel,documentId:scope.row.booked3.documentId}}" class="prepare" tag="div">{{$t('lang.homePage33')}}</router-link>
                          <div v-else class="no-prepare">
                            <i v-if="scope.row.booked3.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked3.displayName}}</i>  
                            <i v-else>{{$t('lang.homePage13')}}</i>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('lang.homePage23')"
                    :render-header="renderHeader"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="hot" v-if="scope.row.hot4"></div>
                      <div class="gray" v-if="scope.row.expired4"></div>
                      <div v-else class="timeZomePopover" v-on:mouseenter="tableTipIn(`${scope.row.localDay4} ${scope.row.localTime4}`,`${scope.row.BeijingDay4} ${scope.row.BeijingTime4}`)" v-on:mouseleave="tableTipOut">
                      </div>
                      <div class="temp" v-if="scope.row.selectedTemp4 && !scope.row.selected4"> 
                        <el-checkbox v-model="scope.row.selectedTemp4" @change="cancelTime(scope.row.selectedTempId4)">{{scope.row.selectedTempText4}}</el-checkbox>
                      </div>
                      <div class="selected" v-if="scope.row.selected4"> 
                        <div v-if="scope.row.expired4" class="passed-selected">{{$t('lang.homePage27')}}</div>
                        <div v-else class="p-r">
                          <div class="selected-layer"></div>
                          <el-checkbox v-model="scope.row.selected4">{{scope.row.selectedText4}}</el-checkbox>
                        </div>
                      </div>
                      <div class="booked" v-if="scope.row.booked4">
                        <div v-if="scope.row.booked4.lessonStatus===2" class="lessonStatus lessonStatus-2">
                          <span v-if="scope.row.booked4.displayName">{{$t('lang.homePage28')}}-{{scope.row.booked4.displayName}}</span>
                          <span v-else>{{$t('lang.homePage28')}}</span>
                        </div>
                        <div v-else-if="scope.row.booked4.lessonStatus===3" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage29')}}
                        </div>
                        <div v-else-if="scope.row.booked4.lessonStatus===4" class="lessonStatus lessonStatus-4">
                          {{$t('lang.homePage30')}}
                        </div>
                        <div v-else-if="scope.row.booked4.lessonStatus===5" class="lessonStatus lessonStatus-5">
                          {{$t('lang.homePage31')}}
                        </div>
                        <div v-else-if="scope.row.booked4.lessonStatus===6" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage32')}}
                        </div>
                        <div v-else class="courseType" :class="`courseType-${scope.row.booked4.courseType}`" v-on:mouseenter="tableTipIn(null, null, scope.row.booked4.displayName, scope.row.booked4.age, scope.row.booked4.level, scope.row.booked4.lesson, scope.row.booked4.date, scope.row.booked4.time)" v-on:mouseleave="tableTipOut">
                          <span v-if="scope.row.booked4.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked4.displayName}}</span>
                          <span v-else>{{$t('lang.homePage13')}}</span>
                          <router-link v-if="scope.row.booked4.roomId" :to="{path:'/classroom/lessonInfo',query:{lessonId:scope.row.booked4.id,title:scope.row.booked4.lesson,roomId:scope.row.booked4.roomId,lessonModel:scope.row.booked4.lessonModel,documentId:scope.row.booked4.documentId}}" class="prepare" tag="div">{{$t('lang.homePage33')}}</router-link>
                          <div v-else class="no-prepare">
                            <i v-if="scope.row.booked4.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked4.displayName}}</i>  
                            <i v-else>{{$t('lang.homePage13')}}</i>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('lang.homePage24')"
                    :render-header="renderHeader"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="hot" v-if="scope.row.hot5"></div>
                      <div class="gray" v-if="scope.row.expired5"></div>
                      <div v-else class="timeZomePopover" v-on:mouseenter="tableTipIn(`${scope.row.localDay5} ${scope.row.localTime5}`,`${scope.row.BeijingDay5} ${scope.row.BeijingTime5}`)" v-on:mouseleave="tableTipOut">
                      </div>
                      <div class="temp" v-if="scope.row.selectedTemp5 && !scope.row.selected5"> 
                        <el-checkbox v-model="scope.row.selectedTemp5" @change="cancelTime(scope.row.selectedTempId5)">{{scope.row.selectedTempText5}}</el-checkbox>
                      </div>
                      <div class="selected" v-if="scope.row.selected5"> 
                        <div v-if="scope.row.expired5" class="passed-selected">{{$t('lang.homePage27')}}</div>
                        <div v-else class="p-r">
                          <div class="selected-layer"></div>
                          <el-checkbox v-model="scope.row.selected5">{{scope.row.selectedText5}}</el-checkbox>
                        </div>
                      </div>
                      <div class="booked" v-if="scope.row.booked5">
                        <div v-if="scope.row.booked5.lessonStatus===2" class="lessonStatus lessonStatus-2">
                          <span v-if="scope.row.booked5.displayName">{{$t('lang.homePage28')}}-{{scope.row.booked5.displayName}}</span>
                          <span v-else>{{$t('lang.homePage28')}}</span>
                        </div>
                        <div v-else-if="scope.row.booked5.lessonStatus===3" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage29')}}
                        </div>
                        <div v-else-if="scope.row.booked5.lessonStatus===4" class="lessonStatus lessonStatus-4">
                          {{$t('lang.homePage30')}}
                        </div>
                        <div v-else-if="scope.row.booked5.lessonStatus===5" class="lessonStatus lessonStatus-5">
                          {{$t('lang.homePage31')}}
                        </div>
                        <div v-else-if="scope.row.booked5.lessonStatus===6" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage32')}}
                        </div>
                        <div v-else class="courseType" :class="`courseType-${scope.row.booked5.courseType}`" v-on:mouseenter="tableTipIn(null, null, scope.row.booked5.displayName, scope.row.booked5.age, scope.row.booked5.level, scope.row.booked5.lesson, scope.row.booked5.date, scope.row.booked5.time)" v-on:mouseleave="tableTipOut">
                          <span v-if="scope.row.booked5.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked5.displayName}}</span>
                          <span v-else>{{$t('lang.homePage13')}}</span>
                          <router-link v-if="scope.row.booked5.roomId" :to="{path:'/classroom/lessonInfo',query:{lessonId:scope.row.booked5.id,title:scope.row.booked5.lesson,roomId:scope.row.booked5.roomId,lessonModel:scope.row.booked5.lessonModel,documentId:scope.row.booked5.documentId}}" class="prepare" tag="div">{{$t('lang.homePage33')}}</router-link>
                          <div v-else class="no-prepare">
                            <i v-if="scope.row.booked5.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked5.displayName}}</i>  
                            <i v-else>{{$t('lang.homePage13')}}</i>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('lang.homePage25')"
                    :render-header="renderHeader"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="hot" v-if="scope.row.hot6"></div>
                      <div class="gray" v-if="scope.row.expired6"></div>
                      <div v-else class="timeZomePopover" v-on:mouseenter="tableTipIn(`${scope.row.localDay6} ${scope.row.localTime6}`,`${scope.row.BeijingDay6} ${scope.row.BeijingTime6}`)" v-on:mouseleave="tableTipOut">
                      </div>
                      <div class="temp" v-if="scope.row.selectedTemp6 && !scope.row.selected6"> 
                        <el-checkbox v-model="scope.row.selectedTemp6" @change="cancelTime(scope.row.selectedTempId6)">{{scope.row.selectedTempText6}}</el-checkbox>
                      </div>
                      <div class="selected" v-if="scope.row.selected6"> 
                        <div v-if="scope.row.expired6" class="passed-selected">{{$t('lang.homePage27')}}</div>
                        <div v-else class="p-r">
                          <div class="selected-layer"></div>
                          <el-checkbox v-model="scope.row.selected6">{{scope.row.selectedText6}}</el-checkbox>
                        </div>
                      </div>
                      <div class="booked" v-if="scope.row.booked6">
                        <div v-if="scope.row.booked6.lessonStatus===2" class="lessonStatus lessonStatus-2">
                          <span v-if="scope.row.booked6.displayName">{{$t('lang.homePage28')}}-{{scope.row.booked6.displayName}}</span>
                          <span v-else>{{$t('lang.homePage28')}}</span>
                        </div>
                        <div v-else-if="scope.row.booked6.lessonStatus===3" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage29')}}
                        </div>
                        <div v-else-if="scope.row.booked6.lessonStatus===4" class="lessonStatus lessonStatus-4">
                          {{$t('lang.homePage30')}}
                        </div>
                        <div v-else-if="scope.row.booked6.lessonStatus===5" class="lessonStatus lessonStatus-5">
                          {{$t('lang.homePage31')}}
                        </div>
                        <div v-else-if="scope.row.booked6.lessonStatus===6" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage32')}}
                        </div>
                        <div v-else class="courseType" :class="`courseType-${scope.row.booked6.courseType}`" v-on:mouseenter="tableTipIn(null, null, scope.row.booked6.displayName, scope.row.booked6.age, scope.row.booked6.level, scope.row.booked6.lesson, scope.row.booked6.date, scope.row.booked6.time)" v-on:mouseleave="tableTipOut">
                          <span v-if="scope.row.booked6.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked6.displayName}}</span>
                          <span v-else>{{$t('lang.homePage13')}}</span>
                          <router-link v-if="scope.row.booked6.roomId" :to="{path:'/classroom/lessonInfo',query:{lessonId:scope.row.booked6.id,title:scope.row.booked6.lesson,roomId:scope.row.booked6.roomId,lessonModel:scope.row.booked6.lessonModel,documentId:scope.row.booked6.documentId}}" class="prepare" tag="div">{{$t('lang.homePage33')}}</router-link>
                          <div v-else class="no-prepare">
                            <i v-if="scope.row.booked6.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked6.displayName}}</i>  
                            <i v-else>{{$t('lang.homePage13')}}</i>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('lang.homePage26')"
                    :render-header="renderHeader"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <div class="hot" v-if="scope.row.hot7"></div>
                      <div class="gray" v-if="scope.row.expired7"></div>
                      <div v-else class="timeZomePopover" v-on:mouseenter="tableTipIn(`${scope.row.localDay7} ${scope.row.localTime7}`,`${scope.row.BeijingDay7} ${scope.row.BeijingTime7}`)" v-on:mouseleave="tableTipOut">
                      </div>
                      <div class="temp" v-if="scope.row.selectedTemp7 && !scope.row.selected7"> 
                        <el-checkbox v-model="scope.row.selectedTemp7" @change="cancelTime(scope.row.selectedTempId7)">{{scope.row.selectedTempText7}}</el-checkbox>
                      </div>
                      <div class="selected" v-if="scope.row.selected7"> 
                        <div v-if="scope.row.expired7" class="passed-selected">{{$t('lang.homePage27')}}</div>
                        <div v-else class="p-r">
                          <div class="selected-layer"></div>
                          <el-checkbox v-model="scope.row.selected7">{{scope.row.selectedText7}}</el-checkbox>
                        </div>
                      </div>
                      <div class="booked" v-if="scope.row.booked7">
                        <div v-if="scope.row.booked7.lessonStatus===2" class="lessonStatus lessonStatus-2">
                          <span v-if="scope.row.booked7.displayName">{{$t('lang.homePage28')}}-{{scope.row.booked7.displayName}}</span>
                          <span v-else>{{$t('lang.homePage28')}}</span>
                        </div>
                        <div v-else-if="scope.row.booked7.lessonStatus===3" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage29')}}
                        </div>
                        <div v-else-if="scope.row.booked7.lessonStatus===4" class="lessonStatus lessonStatus-4">
                          {{$t('lang.homePage30')}}
                        </div>
                        <div v-else-if="scope.row.booked7.lessonStatus===5" class="lessonStatus lessonStatus-5">
                          {{$t('lang.homePage31')}}
                        </div>
                        <div v-else-if="scope.row.booked7.lessonStatus===6" class="lessonStatus lessonStatus-3">
                          {{$t('lang.homePage32')}}
                        </div>
                        <div v-else class="courseType" :class="`courseType-${scope.row.booked7.courseType}`" v-on:mouseenter="tableTipIn(null, null, scope.row.booked7.displayName, scope.row.booked7.age, scope.row.booked7.level, scope.row.booked7.lesson, scope.row.booked7.date, scope.row.booked7.time)" v-on:mouseleave="tableTipOut">
                          <span v-if="scope.row.booked7.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked7.displayName}}</span>
                          <span v-else>{{$t('lang.homePage13')}}</span>
                          <router-link v-if="scope.row.booked7.roomId" :to="{path:'/classroom/lessonInfo',query:{lessonId:scope.row.booked7.id,title:scope.row.booked7.lesson,roomId:scope.row.booked7.roomId,lessonModel:scope.row.booked7.lessonModel,documentId:scope.row.booked7.documentId}}" class="prepare" tag="div">{{$t('lang.homePage33')}}</router-link>
                          <div v-else class="no-prepare">
                            <i v-if="scope.row.booked7.displayName">{{$t('lang.homePage13')}}-{{scope.row.booked7.displayName}}</i>  
                            <i v-else>{{$t('lang.homePage13')}}</i>
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
            <div class="no-syllabus" v-else>
              <div class="box box-full">
                <div class="box-inner">
                  <p>Please choose your convenient time for class</p>
                  <router-link to="/booking" tag="div" class="btn" v-if="!isDemofade">Add</router-link>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="app-bg"></div>
    <div class="demo-box" v-bind:class="{ fade: isDemofade}">
      <!-- <div class="demo-1">
        <div class="demo-message">
          <p>{{$t('lang.demoPage1')}}</p>
          <router-link tag="div" to="/booking" class="next-btn">{{$t('lang.demoPage2')}}</router-link>
        </div>
        <div class="btn">{{$t('lang.demoPage3')}}</div>
      </div> -->
      <div class="demo-1" v-if="demoNum===1">
        <div class="demo-message">
          <div class="cartoon"></div>
          <p>{{$t('lang.demoPage10')}}</p>
          <div class="skip-btn" @click="closeDome">{{$t('lang.demoPage9')}}</div>
          <div class="next-btn" @click="demoNext(2)">{{$t('lang.demoPage2')}}</div>
          <div class="lang">{{$t('lang.demoPage13')}}<span>{{$t('lang.demoPage15')}}</span></div>
          </div>
      </div>
       <div class="demo-2" v-if="demoNum===2">
        <div class="demo-message">
          <div class="cartoon"></div>
          <p>{{$t('lang.demoPage11')}}</p>
          <div class="skip-btn" @click="closeDome">{{$t('lang.demoPage9')}}</div>
          <div class="next-btn" @click="demoNext(3)">{{$t('lang.demoPage2')}}</div>
          <div class="edit">{{$t('lang.userPage92')}}</div>
          </div>
      </div>
      <div class="demo-3" v-if="demoNum===3">
        <div class="demo-message">
          <div class="cartoon"></div>
          <p>{{$t('lang.demoPage12')}}</p>
          <!-- <div class="next-btn" @click="closeDome">{{$t('lang.demoPage14')}}</div> -->
          <div class="skip-btn" @click="closeDome">{{$t('lang.demoPage9')}}</div>
          <router-link tag="div" to="/booking" class="next-btn">{{$t('lang.demoPage2')}}</router-link>
          <div class="selected">{{$t('lang.silderPage3')}}</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "components/app-header/app-header";
import AppSilder from "components/app-silder/app-silder";
import { ERR_OK, TIME_ZONE } from "api/config";
import _ from "lodash";
import store from '../../store';
import {
  getLatestLesson,
  getCurrtWeekScheduledCount,
  getlessonsHomePage
} from "api/course";
import moment from "moment-timezone";

export default {
  data() {
    return {
      ScheduledCount: [
        {
          bookingNum: 0, // 可被学生预约
          bookedNum: 0, // 已被预约 1V1
          openClassNum: 0, // 已被预约公开课
          auditionClassNum: 0, // 已被预约试听课
          teamNum: 0 // 已被预约 1Vn
        }
      ],
      timeZone: moment.tz.guess(),
      listQuery: {
        week: 0,
        startWeek: "",
        endWeek: ""
      },
      week: [],
      demoNum: 1,
      beijingTableData: [
        {
          text: "08:00 AM",
          time: "08:00:00",
          id: 1
        },
        {
          text: "08:30 AM",
          time: "08:30:00",
          id: 2
        },
        {
          text: "09:00 AM",
          time: "09:00:00",
          id: 3
        },
        {
          text: "09:30 AM",
          time: "09:30:00",
          id: 4
        },
        {
          text: "10:00 AM",
          time: "10:00:00",
          id: 5
        },
        {
          text: "10:30 AM",
          time: "10:30:00",
          id: 6
        },
        {
          text: "11:00 AM",
          time: "11:00:00",
          id: 7
        },
        {
          text: "11:30 AM",
          time: "11:30:00",
          id: 8
        },
        {
          text: "12:00 PM",
          time: "12:00:00",
          id: 9
        },
        {
          text: "12:30 PM",
          time: "12:30:00",
          id: 10
        },
        {
          text: "13:00 PM",
          time: "13:00:00",
          id: 11
        },
        {
          text: "13:30 PM",
          time: "13:30:00",
          id: 12
        },
        {
          text: "14:00 PM",
          time: "14:00:00",
          id: 13
        },
        {
          text: "14:30 PM",
          time: "14:30:00",
          id: 14
        },
        {
          text: "15:00 PM",
          time: "15:00:00",
          id: 15
        },
        {
          text: "15:30 PM",
          time: "15:30:00",
          id: 16
        },
        {
          text: "16:00 PM",
          time: "16:00:00",
          id: 17
        },
        {
          text: "16:30 PM",
          time: "16:30:00",
          id: 18
        },
        {
          text: "17:00 PM",
          time: "17:00:00",
          id: 19
        },
        {
          text: "17:30 PM",
          time: "17:30:00",
          id: 20
        },
        {
          text: "18:00 PM",
          time: "18:00:00",
          id: 21
        },
        {
          text: "18:30 PM",
          time: "18:30:00",
          id: 22
        },
        {
          text: "19:00 PM",
          time: "19:00:00",
          id: 23
        },
        {
          text: "19:30 PM",
          time: "19:30:00",
          id: 24
        },
        {
          text: "20:00 PM",
          time: "20:00:00",
          id: 25
        },
        {
          text: "20:30 PM",
          time: "20:30:00",
          id: 26
        }
      ],
      tableData: [
        {
          text: "12:00 AM",
          time: "00:00:00",
          id: 1
        },
        {
          text: "12:30 AM",
          time: "00:30:00",
          id: 2
        },
        {
          text: "01:00 AM",
          time: "01:00:00",
          id: 3
        },
        {
          text: "01:30 AM",
          time: "01:30:00",
          id: 4
        },
        {
          text: "02:00 AM",
          time: "02:00:00",
          id: 5
        },
        {
          text: "02:30 AM",
          time: "02:30:00",
          id: 6
        },
        {
          text: "03:00 AM",
          time: "03:00:00",
          id: 7
        },
        {
          text: "03:30 AM",
          time: "03:30:00",
          id: 8
        },
        {
          text: "04:00 AM",
          time: "04:00:00",
          id: 9
        },
        {
          text: "04:30 AM",
          time: "04:30:00",
          id: 10
        },
        {
          text: "05:00 AM",
          time: "05:00:00",
          id: 11
        },
        {
          text: "05:30 AM",
          time: "05:30:00",
          id: 12
        },
        {
          text: "06:00 AM",
          time: "06:00:00",
          id: 13
        },
        {
          text: "06:30 AM",
          time: "06:30:00",
          id: 14
        },
        {
          text: "07:00 AM",
          time: "07:00:00",
          id: 15
        },
        {
          text: "07:30 AM",
          time: "07:30:00",
          id: 16
        },
        {
          text: "07:00 PM",
          time: "19:00:00",
          id: 17
        },
        {
          text: "07:30 PM",
          time: "19:30:00",
          id: 18
        },
        {
          text: "08:00 PM",
          time: "20:00:00",
          id: 19
        },
        {
          text: "08:30 PM",
          time: "20:30:00",
          id: 20
        },
        {
          text: "09:00 PM",
          time: "21:00:00",
          id: 21
        },
        {
          text: "09:30 PM",
          time: "21:30:00",
          id: 22
        },
        {
          text: "10:00 PM",
          time: "22:00:00",
          id: 23
        },
        {
          text: "10:30 PM",
          time: "22:30:00",
          id: 24
        },
        {
          text: "11:00 PM",
          time: "23:00:00",
          id: 25
        },
        {
          text: "11:30 PM",
          time: "23:30:00",
          id: 26
        }
      ],
      scrollFlag: false,
      tableTip: {
        localtime: "",
        beijingtime: "",
        displayName: "",
        age: "",
        level: "",
        lesson: "",
        date: "",
        time: ""
      },
      comingSoon: [],
      lessonInfos: [],
      unScheduled: [],
      isDemofade: false,
      language: ""
    };
  },
  created() {
    this.handleWeixin();
    this.getTimeZone();
    this._getLatestLesson();
    this._checkFirstLogin();
    this.setLanguage();
    console.log('20210930')
  },
  mounted() {
    this.handleScroll();
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let table = document.querySelector(".syllabus-box-inner");
      if (table) {
        let tableTop =
          table.getBoundingClientRect().top + document.body.scrollTop;
        if (tableTop < 0) {
          this.scrollFlag = true;
        } else {
          this.scrollFlag = false;
        }
      }
    },
    tableTipIn(
      localtime,
      beijingtime,
      displayName,
      age,
      level,
      lesson,
      date,
      time
    ) {
      this.tableTip.localtime = localtime;
      this.tableTip.beijingtime = beijingtime;
      this.tableTip.displayName = displayName;
      this.tableTip.age = age;
      this.tableTip.level = level;
      this.tableTip.lesson = lesson;
      this.tableTip.date = date;
      this.tableTip.time = time;
    },
    tableTipOut() {
      this.tableTip = {
        localtime: "",
        beijingtime: "",
        displayName: "",
        age: "",
        level: "",
        lesson: "",
        date: "",
        time: ""
      };
    },
    getTimeZone() {
      if (TIME_ZONE.indexOf(this.timeZone) > -1) {
        alert("No time zone");
      } else {
        moment.tz.setDefault(this.timeZone);
        this.getLocalWeek();
        this._getCurrtWeekScheduledCount();
      }
    },
    getLocalWeek() {
      this.week = [];
      for (let i = 0; i < 7; i++) {
        var day = moment()
          .tz(this.timeZone)
          .add(this.listQuery.week, "weeks")
          .startOf("isoWeek")
          .add(i, "days")
          .format("YYYY-MM-DD");
        this.week.push(day);
      }
      this.listQuery.startWeek = this.formatBeijingYYYYMMDDHHmmss(
        `${this.week[0]} 00:00`
      );
      this.listQuery.endWeek = this.formatBeijingYYYYMMDDHHmmss(
        `${this.week[6]} 23:59`
      );
      this._getlessonsHomePage(1);
    },
    makelocalTimeTableDate() {
      let day = moment()
        .add(this.listQuery.week, "weeks")
        .startOf("iosWeek")
        .format("YYYY-MM-DD");
      for (let i = 0; i < this.beijingTableData.length; i++) {
        this.tableData[i].time = moment
          .tz(`${day} ${this.beijingTableData[i]["time"]}`, "Asia/Shanghai")
          .tz(this.timeZone)
          .format("HH:mm:ss");
        var order =
          moment
            .tz(`${day} ${this.tableData[i]["time"]}`, this.timeZone)
            .hours() *
            60 +
          moment
            .tz(`${day} ${this.tableData[i]["time"]}`, this.timeZone)
            .minutes();
        this.tableData[i].text = moment
          .tz(`${day} ${this.beijingTableData[i]["time"]}`, "Asia/Shanghai")
          .tz(this.timeZone)
          .format("hh:mm A");
        this.$set(this.tableData[i], `order`, order);
      }
    },
    _checkFirstLogin() {
      var done = localStorage.getItem("done");
      if (done !== "done") {
        this.openDome();
      }
    },
    formTableData() {
      var now = moment().unix();
      for (var i = 1; i < 8; i++) {
        var day = moment()
          .tz(this.timeZone)
          .add(this.listQuery.week, "weeks")
          .startOf("isoWeek")
          .add(i - 1, "days")
          .format("YYYY-MM-DD");
        for (var j = 0; j < this.tableData.length; j++) {
          var targetTime = moment(day + " " + this.tableData[j]["time"]).unix();
          var beijinghotStart = moment(day + " 18:59:00 +800").unix();
          var beijinghotEnd = moment(day + " 20:31:00 +800").unix();
          if (targetTime > beijinghotStart && targetTime < beijinghotEnd) {
            this.$set(this.tableData[j], `hot${i}`, true);
            this.$set(this.tableData[j], `hot0`, true);
          }
          var NightStart = moment(day + " 11:59:00").unix();
          var NightEnd = moment(day + " 23:59:00").unix();
          if (targetTime > NightStart && targetTime < NightEnd) {
            this.$set(this.tableData[j], `night0`, true);
          }
          if (now > targetTime) {
            this.$set(this.tableData[j], `expired${i}`, true);
          }

          this.$set(this.tableData[j], `localDay${i}`, day);
          this.$set(
            this.tableData[j],
            `localTime${i}`,
            this.tableData[j]["text"]
          );
          this.$set(
            this.tableData[j],
            `BeijingDay${i}`,
            this.formatBeijingYYYYMMDD(day + " " + this.tableData[j]["time"])
          );
          this.$set(
            this.tableData[j],
            `BeijingTime${i}`,
            this.formatBeijinghhmmA(day + " " + this.tableData[j]["time"])
          );
        }
      }
      this.tableData = _.sortBy(this.tableData, ["order"]);
    },
    formTableDataRow(startHHmmss) {
      let formTableDataRowTime = [];
      for (let i = 0; i < this.tableData.length; i++) {
        formTableDataRowTime.push(this.tableData[i].time);
      }
      return formTableDataRowTime.indexOf(startHHmmss) + 1;
    },
    formatLocalTimeYYYYMMDDHHmmss(s) {
      if (s) {
        return moment
          .tz(s, "Asia/Shanghai")
          .tz(this.timeZone)
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    formatBeijingYYYYMMDDHHmmss(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    formatBeijingYYYYMMDD(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("YYYY-MM-DD");
      } else {
        return "";
      }
    },
    formatBeijinghhmmA(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("hh:mm A");
      } else {
        return "";
      }
    },
    formatBeijingHHmmss(s) {
      if (s) {
        return moment
          .tz(s, this.timeZone)
          .tz("Asia/Shanghai")
          .format("HH:mm:ss");
      } else {
        return "";
      }
    },
    _getLatestLesson() {
      getLatestLesson()
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.comingSoon = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _getCurrtWeekScheduledCount() {
      getCurrtWeekScheduledCount(this.listQuery)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.ScheduledCount = [];
              this.ScheduledCount.push(response.data.data);
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _getlessonsHomePage(flag) {
      getlessonsHomePage(this.listQuery)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              if (flag === 1) {
                this.makelocalTimeTableDate();
                this.formTableData();
              }
              this.lessonInfos = response.data.data.lessonInfos;
              for (let i = 0; i < this.lessonInfos.length; i++) {
                let data = this.lessonInfos[i];
                let dataTime = this.formatLocalTimeYYYYMMDDHHmmss(
                  this.lessonInfos[i].startTimeBase || this.lessonInfos[i].startTime
                );
                let dataTimeActual = this.formatLocalTimeYYYYMMDDHHmmss(
                  this.lessonInfos[i].startTime
                );
                let startDate = moment(dataTime).days();
                if (startDate === 0) {
                  startDate = 7;
                }
                let displayName = "";
                let age = "";
                if (data.stuSimpInfo[0]) {
                  // displayName = data.stuSimpInfo[0].childCnName;
                  displayName = this.language === 'cn' ? data.stuSimpInfo[0].childCnName : data.stuSimpInfo[0].childEnName;
                  age = data.stuSimpInfo[0].age;
                }
                let lessonInfo = {
                  displayName: displayName,
                  age: age,
                  level: data.courseName,
                  lesson: data.lessonName,
                  date: moment(dataTime).format("YYYY-MM-DD"),
                  time: moment(dataTimeActual).format("hh:mm A"),
                  id: data.id,
                  documentId: data.documentId,
                  roomId: data.roomId,
                  lessonModel: data.lessonModel,
                  courseType: data.trial ? 3 : data.courseType,
                  lessonStatus: data.lessonStatus
                };
                let startHHmmss = moment(dataTime).format("HH:mm:ss");
                let row = this.formTableDataRow(startHHmmss);
                if (this.tableData[row - 1]) {
                  this.$set(
                    this.tableData[row - 1],
                    `booked${startDate}`,
                    lessonInfo
                  );
                }
              }
              this.unScheduled = response.data.data.unScheduled;
              for (let i = 0; i < this.unScheduled.length; i++) {
                let data = this.formatLocalTimeYYYYMMDDHHmmss(
                  `${this.unScheduled[i].startDate} ${
                    this.unScheduled[i].startTime
                  }`
                );
                let startDate = moment(data).days();
                if (startDate === 0) {
                  startDate = 7;
                }
                let startHHmmss = moment(data).format("HH:mm:ss");
                let row = this.formTableDataRow(startHHmmss);
                if (this.tableData[row - 1]) {
                  this.$set(
                    this.tableData[row - 1],
                    `selected${startDate}`,
                    true
                  );
                  this.$set(
                    this.tableData[row - 1],
                    `selectedText${startDate}`,
                    moment(data).format("hh:mm A")
                  );
                }
              }
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    openDome() {
      this.isDemofade = true;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      document.body.setAttribute("class", "dialogfade");
    },
    demoNext(index) {
      this.demoNum = index;
    },
    closeDome() {
      this.isDemofade = false;
      document.body.removeAttribute("class", "dialogfade");
      localStorage.setItem("done", "done");
    },
    renderHeader(h, { column, $index }) {
      var targetString = moment()
        .tz(this.timeZone)
        .add(this.listQuery.week, "weeks")
        .startOf("isoWeek")
        .add($index - 1, "days")
        .format("YYYY-MM-DD");
      return h("div", {}, [h("label", null, column.label), targetString]);
    },
    setLanguage() {
      this.language = store.state.app.language;
    },
    isWeixin() {
      const u = navigator.userAgent;
      if (u.indexOf("MicroMessenger") > -1) {
        return true
      } else {
        return false
      }
    },
    handleWeixin() {
      if (this.isWeixin()) {
        this.$router.push({ path: "/m/home" });
      }
    }
  },
  components: {
    AppHeader,
    AppSilder
  },
  watch: {
    '$i18n.locale' () {
      this.getTimeZone();
      this._getLatestLesson();
      this.setLanguage();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.app-main-inner {
  background: transparent;
  border: 0px;
}
.comingSoon-box {
  background-color: $baseColor;
  padding: 20px;
  color: #fff;
  height: 60px;
  margin-bottom: 10px;
  h1 {
    font-size: 20px;
    margin: 0px 0px 15px;
  }
  .comingSoon-info {
    height: 26px;
    line-height: 26px;
    span {
      color: #fff;
      padding: 0px 10px;
      border-right: 1px solid #fff;
      &.padding-left-0 {
        padding-left: 0px;
      }
      i {
        font-style: normal;
      }
    }
    .enter-btn {
      display: inline-block;
      border: 1px solid #ffffff;
      border-radius: 20px;
      color: #fff;
      width: 75px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      float: right;
      font-size: 12px;
      cursor: pointer;
    }
  }
}
.ScheduledCount-box {
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 30px;
}
.syllabus-box {
  .syllabus-box-top {
    height: 32px;
    line-height: 32px;
    margin-bottom: 20px;
    h1 {
      display: inline-block;
      float: left;
      font-size: 20px;
      color: #333333;
      margin: 0px 30px 0px 0px;
    }
    span {
      color: #bebebe;
      font-size: 12px;
      margin-right: 30px;
      i {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 5px;
        border-radius: 50%;
      }
    }
    .syllabus-btn {
      display: inline-block;
      background: rgba(255, 164, 56, 0.5);
      border: 1px solid #ffa438;
      border-radius: 20px;
      color: #fff;
      width: 110px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
    }
  }
  .syllabus-box-inner {
    &.scroll {
      .table-tip {
        position: fixed;
        top: 0px;
        width: 928px;
        z-index: 999;
        overflow: hidden;
      }
    }
    .table-tip {
      height: 50px;
      line-height: 50px;
      padding-left: 50px;
      position: relative;
      background-color: #fff;
      border-top: 1px solid #ebeef5;
      border-left: 1px solid #ebeef5;
      border-right: 1px solid #ebeef5;
      border-bottom: 1px solid #000;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      i {
        display: block;
        width: 18px;
        height: 24px;
        background: url(~assets/images/Details.png) center center no-repeat;
        background-size: cover;
        position: absolute;
        top: 14px;
        left: 18px;
      }
      h1 {
        color: #000;
        font-weight: bold;
        font-size: 15px;
        margin: 0;
        display: inline-block;
        margin-right: 30px;
      }
      .table-tip-info {
        span {
          margin-right: 20px;
          color: #333;
          b {
            color: #ffa438;
          }
        }
      }
    }
  }
  .no-syllabus {
    background-color: #fff;
    border: 1px solid #dedede;
    border-radius: 5px;
    height: 240px;
    p {
      font-size: 16px;
      margin-bottom: 30px;
    }
    .btn {
      display: inline-block;
      width: 130px;
      height: 32px;
      line-height: 26px;
    }
  }
  .no-syllabus {
    background-color: #fff;
    border: 1px solid #dedede;
    border-radius: 5px;
    height: 240px;
    p {
      font-size: 16px;
      margin-bottom: 30px;
    }
    .btn {
      display: inline-block;
      width: 130px;
      height: 32px;
      line-height: 26px;
    }
  }
}

.demo-box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: -9999;
  opacity: 0;
  background: rgba(51, 51, 51, 0.4);
  &.fade {
    opacity: 1;
    z-index: 9999;
  }
  .skip-btn {
    background: #fff;
    border: 1px solid #fff;
    border-radius: 20px;
    color: #ffa438;
    width: 75px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    position: absolute;
    cursor: pointer;
  }
  .next-btn {
    background: rgba(255,174,4,1);
    border: 1px solid #ffa438;
    border-radius: 20px;
    color: #fff;
    width: 75px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    position: absolute;
    cursor: pointer;
  }
  .demo-1 {
    position: absolute;
    top: 100px;
    width: 462px;
    left: 50%;
    margin-left: 41px;
    .demo-message {
      width: 460px;
      height: 90px;
      background: url(~assets/images/Pop-bg.png) no-repeat,linear-gradient(101deg,rgba(255,194,34,1) 0%,rgba(255,173,3,1) 100%);
      background-size: cover;
      box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.11);
      border-radius: 58px;
      position: relative;
      margin: auto;
      margin: 0 0 50px 20px;
      .cartoon {
        position: absolute;
        width: 100px;
        height: 100px;
        left: 40px;
        bottom: -11px;
        background: url(~assets/images/Pop-cartoon.png) center center no-repeat;
        background-size: contain;
      }
      p {
        position: absolute;
        left: 160px;
        top: 18px;
        color: #fff;
      }
      .skip-btn {
        bottom: -70px;
        left: 140px;
      }
      .next-btn {
        bottom: -70px;
        right: 140px;
      }
      .lang {
        position: absolute;
        background: #fff;
        text-align: center;
        color: #ffa438;
        width: 160px;
        top: -86px;
        left: 300px;
        padding: 8px;
        border-radius: 20px;
        border: 1px solid #ffa438;

        span {
          margin-left: 20px;
          float: right;
        }
      }
      &::before {
          position: absolute;
          left: 325px;
          top: -40px;
          content: ""; 
          width: 0;
	        height: 0;
	        border: 20px solid transparent;
	        border-bottom-color: rgba(255,173,3,1);
        }
    }
  }
  .demo-2 {
    position: absolute;
    top: 450px;
    width: 462px;
    left: 50%;
    margin-left: 160px;
    .demo-message {
      width: 460px;
      height: 90px;
      background: url(~assets/images/Pop-bg.png) no-repeat,linear-gradient(101deg,rgba(255,194,34,1) 0%,rgba(255,173,3,1) 100%);
      background-size: cover;
      box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.11);
      border-radius: 58px;
      position: relative;
      margin: auto;
      margin: 0 0 50px 20px;
      .cartoon {
        position: absolute;
        width: 100px;
        height: 100px;
        left: 40px;
        bottom: -11px;
        background: url(~assets/images/Pop-cartoon.png) center center no-repeat;
        background-size: contain;
      }
      p {
        position: absolute;
        left: 160px;
        top: 18px;
        color: #fff;
      }
      .skip-btn {
        bottom: -70px;
        left: 140px;
      }
      .next-btn {
        bottom: -70px;
        right: 140px;
      }
      .edit {
        position: absolute;
        top: -91px;
        left: 308px;
        display: inline-block;
        background: rgba(255, 164, 56, 0.5);
        border: 1px solid #ffa438;
        border-radius: 20px;
        color: #fff;
        width: 110px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
      }
      &::before {
          position: absolute;
          left: 325px;
          top: -40px;
          content: ""; 
          width: 0;
	        height: 0;
	        border: 20px solid transparent;
	        border-bottom-color: rgba(255,173,3,1);
        }
    }
  }
  .demo-3 {
    position: absolute;
    top: 540px;
    width: 462px;
    left: 50%;
    margin-left: -636px;
    .demo-message {
      width: 460px;
      height: 90px;
      background: url(~assets/images/Pop-bg.png) no-repeat,linear-gradient(101deg,rgba(255,194,34,1) 0%,rgba(255,173,3,1) 100%);
      background-size: cover;
      box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.11);
      border-radius: 58px;
      position: relative;
      margin: auto;
      margin: 0 0 50px 20px;
      .cartoon {
        position: absolute;
        width: 100px;
        height: 100px;
        right: 40px;
        bottom: -11px;
        background: url(~assets/images/Pop-cartoon.png) center center no-repeat;
        background-size: contain;
      }
      p {
        position: absolute;
        left: 28px;
        top: 18px;
        width: 290px;
        color: #fff;
      }
      .skip-btn {
        bottom: -70px;
        left: 140px;
      }
      .next-btn {
        bottom: -70px;
        right: 140px;
      }
      .selected {
        position: absolute;
        top: -74px;
        left: 38px;
        text-align: center;
        display: inline-block;
        background: #fff;
        color: gray;
        border: 2px solid rgba(255,174,4,1);
        border-radius: 20px;
        width: 160px;
        height: 40px;
        line-height: 40px;
      }
      &::before {
          position: absolute;
          right: 325px;
          top: -40px;
          content: ""; 
          width: 0;
	        height: 0;
	        border: 20px solid transparent;
	        border-bottom-color: rgba(255,173,3,1);
        }
    }
  }  
  // .demo-1 {
  //   position: absolute;
  //   top: 60px;
  //   width: 462px;
  //   left: 50%;
  //   margin-left: 44px;
  //   .demo-message {
  //     width: 462px;
  //     height: 452px;
  //     background: url(~assets/images/Pop-1.png) center center no-repeat;
  //     background-size: cover;
  //     position: relative;
  //     margin: 0px 0px 50px 20px;
  //     p {
  //       position: absolute;
  //       right: 20px;
  //       left: 20px;
  //       bottom: 140px;
  //       font-size: 20px;
  //       color: #6a6a6a;
  //     }
  //     .next-btn {
  //       background: rgba(255, 164, 56, 0.5);
  //       border: 1px solid #ffa438;
  //       border-radius: 20px;
  //       color: #fff;
  //       width: 75px;
  //       height: 32px;
  //       line-height: 32px;
  //       text-align: center;
  //       position: absolute;
  //       bottom: 70px;
  //       right: 60px;
  //       cursor: pointer;
  //     }
  //   }
  //   .btn {
  //     display: inline-block;
  //     width: 130px;
  //     height: 32px;
  //     line-height: 26px;
  //   }
  // }
}
.hot {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 164, 56, 0.3);
  line-height: 35px;
  i {
    display: inline-block;
    width: 10px;
    height: 13px;
    background: url(~assets/images/hot@2x.png) center center no-repeat;
    background-size: cover;
    position: absolute;
    top: 10px;
    left: 10px;
  }
}
.night {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(41, 131, 255, 0.3);
  line-height: 35px;
}
.gray {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #e3e3e3;
}
.timeZomePopover {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0;
  bottom: 0px;
}
.popover-content {
  label {
    color: #000;
    font-weight: bold;
  }
  .btn {
    width: 160px;
    height: 32px;
    line-height: 26px;
    margin: 0px auto;
  }
}
.selected {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0;
  background: #fff;
  z-index: 2;
  label {
    height: 35px;
    line-height: 35px;
    margin: 0 auto;
  }
  .selected-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border: 0;
    z-index: 999;
  }
}
.passed-selected {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #e3e3e3;
  color: #333;
  font-size: 13px;
  line-height: 35px;
}
.temp {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0;
  background: #dedede;
  z-index: 1;
  label {
    height: 35px;
    line-height: 35px;
    margin: 0 auto;
  }
}
.booked {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 0;
  z-index: 2;
  @include ellipsis;
  .lessonStatus {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 35px;
    text-align: center;
    font-size: 12px;
    @include ellipsis;
    &.lessonStatus-2 {
      background: rgba(255, 255, 255, 1);
    }
    &.lessonStatus-3 {
      background: #8f8f8f;
    }
    &.lessonStatus-4 {
      background:  rgba(255, 143, 145, 1);
    }
    &.lessonStatus-5 {
      background: rgba(250, 242, 141, 1);
    }
  }
  .courseType {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    line-height: 35px;
    text-align: center;
    font-size: 12px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &.courseType-0 {
      background: #83e8e8;
    }
    &.courseType-1 {
      background: #ffa438;
    }
    &.courseType-2 {
      background: #FF4B41;
    }
    &.courseType-3 {
      background: #c0b2fa;
    }
    .prepare {
      line-height: 35px;
      color: #fff;
      text-align: center;
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: none;
      font-size: 14px;
    }
    .no-prepare {
      line-height: 35px;
      text-align: center;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      font-size: 12px;
      display: none;
      i {
        font-style: normal;
      }
    }
    &:hover {
      span {
        display: none;
      }
      .prepare {
        display: block;
      }
      .no-prepare {
        display: block;
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/views/course/index.vue